import { globalPlaybackSlice } from "./slice";

export const { selectIsPlaying } = globalPlaybackSlice.selectors;
